const LOG_LEVELS = {
    DEBUG: 'DEBUG',
    WARN: 'WARN',
    ERROR: 'ERROR',
};

export { LOG_LEVELS };
//# sourceMappingURL=logLevels.js.map
